<div [class.two-column-tool-tip]="_showInfo">
    <mat-form-field class="mat-form-field-no-padding" [class.small]="_short">
        <mat-label>{{_label}}</mat-label>
        <app-yes-no  [value]="_value" [name]="_name!" [required]="_required" [disabled]="_disabled || _readOnly" [control]="_control" (onValueChange)="onChange($event)" />
    </mat-form-field>
     @if (_showInfo) {
        <mat-icon color="primary" [matTooltip]="_toolTip"  #tooltip="matTooltip" (click)="tooltip.toggle()">info</mat-icon>
    }
</div>

